import dynamic from "next/dynamic";

const DynamicWhatsNewModal = dynamic(
  () => import("modules/changelog/components/WhatsNewModal"),
  {
    loading: () => <></>,
  }
);

export default DynamicWhatsNewModal;
